<!-- <div class="pagination-wrapper">
    <button class="nav-btn" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)">
      &#10094; &nbsp;&nbsp; Prev
    </button>

    <div>
  
    <ng-container *ngFor="let page of [].constructor(totalPages); let i = index">
      <button
        class="page-btn"
        [ngClass]="{ active: currentPage === i + 1 }"
        (click)="onPageChange(i + 1)"
      >
        {{ i + 1 }}
      </button>
    </ng-container>
    </div>
  
    <button class="nav-btn" [disabled]="currentPage === totalPages" (click)="onPageChange(currentPage + 1)">
      Next &nbsp;&nbsp; &#10095;
    </button>
  </div> -->


  <div class="pagination-wrapper">
  <button class="nav-btn" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)">
    &#10094; &nbsp;&nbsp; Prev
  </button>

  <div>
    <ng-container *ngFor="let page of getPages(); let i = index">
      <button
        *ngIf="page !== '...'; else dots"
        class="page-btn"
        [ngClass]="{ active: currentPage === page }"
        (click)="onPageChange(page)"
      >
        {{ page }}
      </button>

      <ng-template #dots>
        <button class="page-btn dots" disabled>...</button>
      </ng-template>
    </ng-container>
  </div>

  <button class="nav-btn" [disabled]="currentPage === totalPages" (click)="onPageChange(currentPage + 1)">
    Next &nbsp;&nbsp; &#10095;
  </button>
</div>